<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Grid from '../components/Shared/Grid'

export default {
  name: 'EventLog',
  components: {
    Grid
  },
  data () {
    return {
      module: this.$route.meta.module,
      filterable: true,
      advancedSearchOpen: false,
      pagination: {
        rowsNumber: 0,
        rowsPerPage: 10,
        page: 1,
        descending: true,
        sortBy: 'DATE_CREATED'
      },
      columnOptions: [
        { field: row => row.USER.USER_FIRST_NAME, name: 'USER_FIRST_NAME', label: 'First Name', sortable: false, filterable: false, type: 'string' },
        { field: row => row.USER.USER_LAST_NAME, name: 'USER_LAST_NAME', label: 'Last Name', sortable: false, filterable: false, type: 'string' },
        { field: "ENTITY_TYPE", name: 'ENTITY_TYPE', label: 'Entity', sortable: false, filterable: false, type: 'string' },
        { field: "ENTITY_ID", name: 'ENTITY_ID', label: 'ID', sortable: false, filterable: false, type: 'number' },
        { field: "DESCRIPTION", name: 'DESCRIPTION', label: 'Description', sortable: false, filterable: false, type: 'string' },
        { field: "DATE_CREATED", name: 'DATE_CREATED', label: 'Date Created', sortable: true, filterable: false, type: 'date' },
      ],
    }
  },
  mounted() {
  },
  computed: {
    ...mapState('events', {
      list: state => state.list,
      loading: state => state.loading,
    }),
    ...mapGetters('events', [
      'eventList'
    ]),
  },
  methods: {
    ...mapActions('events', [
      'fetchAll',
    ]),
  }
}
</script>

<template>
  <q-page class="stretch-grid has-search no-footer">
    <Grid
      class='fit'
      id="eventsGrid"
      :loading="loading"
      :module="module"
      :data="eventList"
      :columns="columnOptions"
      :pagination="pagination"
      :onRequest="fetchAll"
      :rowsPerPageOptions="[10,20,30,50,100]"
    >
    </Grid>
  </q-page>
</template>


<style>
</style>